import { TextButtonProps } from '../TextButton';

declare global {
  interface Navigator {
    share(data: ShareButtonData): Promise<void>;
  }
}

export interface ShareButtonData {
  url: string;
  text?: string;
  title?: string;
}

export interface ShareButtonProps
  extends Omit<TextButtonProps, 'onClick' | 'children'> {
  onClick(sharePromise: Promise<void> | undefined): void;
  shareData: ShareButtonData;
  withIcon?: boolean;
  text?: React.ReactChild;
}
